import { cn } from "~/common/cn"
import { balanceText } from "~/common/text-utils"
import { AppText } from "~/ui/app-text"
import { UserAvatar } from "~/ui/user-avatar"

interface HostPillProps {
  member: {
    avatarUrl?: string | null
    displayOrUsername?: string | null
    verifiedAccount?: boolean | null
  }
}

export const HostPill = ({ member }: HostPillProps) => {
  const charLimit = 12
  const [firstLine, secondLine] = balanceText(member.displayOrUsername ?? "", charLimit)
  return (
    <div
      className={cn(
        "flex shrink-0 flex-row items-center rounded-full bg-opacity-black px-2 py-1 md:m-1"
      )}
    >
      <UserAvatar
        avatarUrl={member.avatarUrl}
        displayName={member.displayOrUsername || ""}
        verifiedAccount={member.verifiedAccount ?? undefined}
        size={"shareCard"}
        verifiedBadgeSize={"sm"}
      />
      <div className={cn("px-2 py-1")}>
        <AppText
          variant="body2-medium"
          className={cn("line-clamp-2 w-full text-left text-base-white")}
        >
          {secondLine ? (
            <>
              {firstLine}
              <br />
              {secondLine}
            </>
          ) : (
            firstLine
          )}
        </AppText>
      </div>
    </div>
  )
}
